import { useRef, useState } from "react";
import "./style.scss";
import classNames from "classnames";
import OliverText from "@builder/components/general/OliverText";
import { useOutsideClick } from "@builder/hooks/useOutsideClick";
import { useTranslation } from "react-i18next";

interface SelectInputProps {
    title?: string;
    value?: string;
    layout?: "row" | "column";
    className?: string;
    options: Record<string, string>;
    callback: (value: string) => void;
    noTranslate?: boolean;
    placeholder?: string;
    bold?: boolean;
}

const DropdownInput: React.FC<SelectInputProps> = ({
    title,
    value,
    layout = "row",
    className,
    options,
    callback,
    noTranslate,
    placeholder,
    bold
}) => {
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const selectRef = useRef<HTMLInputElement>(null);
    const { t } = useTranslation();

    useOutsideClick(selectRef, () => {
        setIsOpen(false);
    });

    const selectOption = (e: React.MouseEvent) => {
        const value = e.currentTarget.getAttribute("data-value");
        if (typeof value === "string") {
            callback(value);
            setIsOpen(false);
        }
    };

    const selectWrapperClass = classNames("dropdown-input-wrapper", {
        ["layout-row"]: layout === "row",
        ["layout-column"]: layout === "column",
        [`${className}`]: className
    });

    return (
        <div className={selectWrapperClass}>
            {title && <OliverText text={t("popup.actionBuilder." + title)} size="xs" weight={bold ? "medium-heavy" : "medium"} />}
            <div className={["select-wrapper", isOpen && "select-active"].filter(Boolean).join(" ")} ref={selectRef}>
                <img src="/angled-arrow-down.svg" />
                <input
                    type="text"
                    value={(typeof value === "string" && (noTranslate ? options[value] : t("popup.actionBuilder." + options[value]))) || ""}
                    placeholder={placeholder}
                    readOnly
                    onClick={() => setIsOpen(!isOpen)}
                />
                {isOpen && (
                    <div className="select-input-options">
                        {Object.entries(options).map(([value, label], index) => (
                            <div className="select-input-option" key={index} data-value={value} onClick={selectOption}>
                                {noTranslate ? label : t("popup.actionBuilder." + label)}
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default DropdownInput;
